<template>
  <div>
    <MyLayout />
    <router-view></router-view>
  </div>
</template>

<script>
import MyLayout from "./views/layout/layout.vue";

export default {
  name: "App",
  components: {
    MyLayout
  }
};
</script>

<style>
#app {
  height: 100%;
  background-color: #f8f7fb;
  min-height: 100vh;
  padding-bottom: 10px;
}
</style>
